import getProjection from 'owa-popout-v2/lib/utils/getProjection';
import type { AppPaneUnderlayViewState } from 'owa-app-pane-underlay';

export default function getUnderlay(targetWindow: Window): AppPaneUnderlayViewState | undefined {
    const projection = getProjection(targetWindow);
    return projection?.underlay;
}
